import { DefaultContext } from "constants/context/context";
import { createContext } from "react";

export const CommonContext = createContext(DefaultContext);
